import { CalEventFieldType } from '../constants/cal-event-field-type.js';
import { conditionValueMatchesOperator } from './condition-value-matches-operator.js';
import { valueKindForField } from './value-kind-for-field.js';
function isOutsideSelectOptions(rule, fields) {
    const { fieldId, operator, value } = rule.condition;
    const field = fields.find((candidate) => candidate.id === fieldId);
    if (field?.type !== CalEventFieldType.SELECT || field.config === undefined)
        return false;
    if (operator !== 'eq' && operator !== 'in')
        return false;
    const { options = [] } = field.config;
    const values = operator === 'in' ? value : [value];
    return values.some((item) => typeof item !== 'string' || !options.includes(item));
}
export function conditionErrorMessage(rule, allowedOperators, fields) {
    if (!allowedOperators) {
        return `Rule condition references unknown field "${rule.condition.fieldId}".`;
    }
    if (!allowedOperators.includes(rule.condition.operator)) {
        return `Operator "${rule.condition.operator}" is not valid for field "${rule.condition.fieldId}".`;
    }
    if (rule.condition.operator === 'in' &&
        Array.isArray(rule.condition.value) &&
        rule.condition.value.length === 0) {
        return `Rule condition for "${rule.condition.fieldId}" uses "in" with an empty array, which can never match.`;
    }
    const kind = valueKindForField(rule.condition.fieldId, fields);
    if (kind && !conditionValueMatchesOperator(rule.condition.operator, rule.condition.value, kind)) {
        return `Rule condition value for "${rule.condition.fieldId}" does not match the ${kind} type operator "${rule.condition.operator}" requires.`;
    }
    if (kind === 'string' && rule.condition.operator === 'eq' && rule.condition.value === '') {
        return `Rule condition for "${rule.condition.fieldId}" compares against an empty string; use "isEmpty" instead.`;
    }
    if (isOutsideSelectOptions(rule, fields)) {
        return `Rule condition value for "${rule.condition.fieldId}" is not one of that field's options.`;
    }
    return undefined;
}
//# sourceMappingURL=rule-condition-error.js.map